import { TimeUnit } from '../../models';

declare type Prefix = 's' | 'm' | 'h' | 'd' | 'w' | 'M' | 'y';

export class MomentHelper {
    static getFormat(unit: TimeUnit): string {
        let format = '';
        switch (unit) {
            case TimeUnit.Second:
                format = 'ss';
                break;
            case TimeUnit.Minute:
                format = 'mm';
                break;
            case TimeUnit.Hour:
                format = 'HH:mm';
                break;
            case TimeUnit.Day:
                format = 'DD';
                break;
            case TimeUnit.Week:
                format = 'WW';
                break;
            case TimeUnit.Month:
                format = 'MM';
                break;
            case TimeUnit.Year:
                format = 'YY';
                break;
            default:
                break;
        }
        return format;
    }

    static getPrefix(unit: TimeUnit): Prefix {
        let prefix: Prefix = 'm';
        switch (unit) {
            case TimeUnit.Second:
                prefix = 's';
                break;
            case TimeUnit.Minute:
                prefix = 'm';
                break;
            case TimeUnit.Hour:
                prefix = 'h';
                break;
            case TimeUnit.Day:
                prefix = 'd';
                break;
            case TimeUnit.Week:
                prefix = 'w';
                break;
            case TimeUnit.Month:
                prefix = 'M';
                break;
            case TimeUnit.Year:
                prefix = 'y';
                break;
            default:
                break;
        }
        return prefix;
    }
}